import { DetalleRegimenLaboralHEDTO, RegimenLaboralHEDTO } from 'components/DirectivoUnidad/Horas Extras/PlanificacionHE/TypesPlanificacionHE';
import React, { useMemo, useState } from 'react'
import { Card, CardBody, CardTitle, CardFooter, Row, Col,Button } from "reactstrap"
import { ProyeccionRegimenTotalUnidad, ProyeccionTotal } from './TypesProyecionHorasExtrasAdmin';
import { GetNumberFormatHE } from './TablaUnidadesProyeccionHE';

type PropsCardRegimenHE = {
    // regimenLaboralPlan: RegimenLaboralHEDTO;
    // index: number;
    // totalProyeccionUnidades:ProyeccionTotal | null
    regimenLaboralProyectado:ProyeccionRegimenTotalUnidad,
    totalProyeccionUnidades:ProyeccionTotal | null
    index:number
}



export default function CardRegimenHE(props: PropsCardRegimenHE ) {

  const {
    regimenLaboralProyectado,
    totalProyeccionUnidades
  } = props
  let TITULO_CARD = props.regimenLaboralProyectado.siglasRegimen;

  const color = getColor(props.index);  // Función para obtener el color basado en el índice

    // Función para seleccionar un color
    function getColor(index: number) {
        const colors = ['#243561', '#57b631', '#FF7E01'];
        return colors[index % colors.length];  // Usa el módulo para rotar a través de los colores
    }

    let presupuestoProyectado:number|null = null
    let presupuestoEjecutado:number|null = null
    let presupuestoAsignado:number|null = null

    if(totalProyeccionUnidades){
        const regimenProyectado = regimenLaboralProyectado;//totalProyeccionUnidades.valorTotalizadoRegimen.find((v) => v.idRegimenLaboral === regimenLaboralPlan.idRegimenLaboral);
        if(regimenProyectado && regimenProyectado.valorHoras){
            presupuestoProyectado = regimenProyectado.valorHoras;
        }

        if(totalProyeccionUnidades.valorTotalEjecutadoAnioAnterior){
            presupuestoEjecutado = totalProyeccionUnidades.valorTotalEjecutadoAnioAnterior
        }

        if(totalProyeccionUnidades.valorTotalPresupuestoAsignado) {
            presupuestoAsignado = totalProyeccionUnidades.valorTotalPresupuestoAsignado
        }

    }
  
  return (
    <Card >
      <CardTitle className="cardHeaderRegimenPlanificacion" style={{ backgroundColor: color }}  >
      {TITULO_CARD}

      </CardTitle>

      <CardBody>
            <Row>
                <Col xl={12}>
                    <div className='groupInfoRegimenPUTH'>
                        <div className='labelInfoRegimenGrayPUTH'> PRESUPUESTO PROYECTADO: </div>
                        <div className='valueInfoRegimenPUTH'> {GetNumberFormatHE(presupuestoProyectado)}</div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xl={12}>
                    <div className='groupInfoRegimenPUTH'>
                        <div className='labelInfoRegimenGrayPUTH'> PRESUPUESTO EJECUTADO AÑO ANTERIOR: </div>
                        <div className='valueInfoRegimenPUTH'> {GetNumberFormatHE(presupuestoEjecutado)}</div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xl={12}>
                    <div className='groupInfoRegimenPUTH'>
                        <div className='labelInfoRegimenGrayPUTH'> PRESUPUESTO ASIGNADO:</div>
                        <div className='valueInfoRegimenPUTH'> {GetNumberFormatHE(presupuestoAsignado)} </div>
                    </div>
                </Col>
            </Row>
           
      </CardBody>

      {/* <CardFooter>
      <Row>
                <Col xl={12}>
                    <a className='buttonCardInfoRegimen'> Ver más </a>
                </Col>
            </Row>
        
      </CardFooter> */}

    </Card>
  )


}